import React, { useState, useEffect, useContext } from "react";
import Tab from "../tab/tab";
import TopBar from "../../scenes/global/Top-Bar";
import SideBar from "../../scenes/global/Side-Bar";
import BasicSelect from "../select/select";
import { TextArea } from "../textarea/textarea";
import TextInput from "../text_input/text_input";
import AddedItem from "../added_item/added_item";
import ViewProp from "../view_prop/view";
import AddMore from "../add_more/add_more";
import Months from "../../scenes/step/data/month";
import { useSelector, useDispatch } from "react-redux";
import { dispatchActivites, generate_experience, cleanEX, ActivitiesDetails_loading, updateExperience, generate_my_cv, saveExperience } from "../../Redux/ActionCreator";
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useNavigate } from "react-router-dom";
import Radio from "../radio/radio";
import LoaderModal from '../../components/LoaderModal.jsx';
import { LanguageContext } from "../../scenes/global/languageContext";
import { convertExperience } from "../../Redux/convertResume";
import dayjs from "dayjs";

export default function UserWorkExperience(props) {
  const t_lang = useSelector(lg => lg.t_lang)
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const profile = useSelector(e => e.profile);
    const dispatch = useDispatch();
    const exp = useSelector(exp => exp.activities);
    const generated = useSelector(e => e.generateCV);
    const secret = useSelector(prev => prev.secret);
    const cv = useSelector(prev => prev.cvId);
    const AIexp = useSelector(ai => ai.exp);
    const existing_cv_data = useSelector((prev) => prev.existingCV);
    const message = existing_cv_data.message;
    const profile1 = useSelector(e => e.login);
    const userInfo = useSelector(e => e.userInfo);
    let stat = profile1.profile_status.profile_status;
    const [ isRedux, setIsredux ] = useState(false);
    let [ work, setwork ] = useState(props.Experience);
    let [ chips, setChips ] = useState(props.Experience);
    const [ activity, setActivities ] = useState([]);
    const [ experience, setExperience ] = useState("")
    const [ truty, setTruty ] = useState(false);
    let [ incr_defaultEdu, setIncre_defaultEdu ] = useState();
    const [ expStart, setExpStart ] = useState("");
    const [expEnd, setExpEnd ] = useState("");
    const [ expStart1, setExpStart1 ] = useState("");
    const [expEnd1, setExpEnd1 ] = useState("");
    const navigate = useNavigate();
    const expe = AIexp.exp;
    const [ newwork, setNewWork ] = useState([]);
    const [ visibility, setVisibility ] = useState(false);
    const [ color, setColor ] = useState(false);
    const [ e_present, setE_Present ] = useState(false);
    const [ obj, setObj ] = useState()
  
    useEffect(() => {
      if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
        setVisibility(true);
        setwork(profile.message.Experience);
        setChips(profile.message.Experience);
      } else if (window.location.pathname === `/form/${cv.id}/update`) {
        setwork(generated.message.Experience);
        setChips(generated.message.Experience);
      } else {
        if (exp.activities !== null) {
          setwork(exp.activities);
          setChips(exp.activities);
        } else if (message !== null) {
          if (message.Experience !== null && message.Experience !== undefined) {
            setwork(message.Experience);
            setChips(message.Experience);
          } else {
            setwork([]);
            setChips([]);
          }
        } else {
          setwork([]);
          setChips([]);
        }
      }
    }, []);
  
    useEffect(() => {
      if (obj !== undefined) {
        dispatch(generate_my_cv(obj));
      }
    }, [obj])
  
  
    useEffect(() => {
      if ($('[name="work_day_activities"]').val() === "") {
        setColor(false);
      } else {
        setColor(true);
      }
    }, [$('[name="work_day_activities"]').val()])

    useEffect(() => {
      $('input[name="present"]').on("click", () => {
        setE_Present(!e_present)
        if (e_present === true) {
          $('#present').prop('checked', false);
        } else {
          $('#present').prop('checked', true);
        }
      });
    }, [e_present]);
    console.log("Present", e_present);
    /* 
    useEffect(() => {
      $('input[name="present"]').on("click", () => {
        console.log("Exp present was called.")
        setE_Present(!e_present);
        if (e_present === true) {
          $('#present').prop('checked', false);
        } else {
          $('#present').prop('checked', true);
        }
      })
    }, [e_present]);
    console.log("Present", e_present);
 */
    useEffect(() => {
      if (newwork.length !== 0) {
        dispatch(updateExperience(newwork));
        navigate("/user/profile");
      }
    }, [newwork]);
  
    useEffect(() => {
      
      if (message !== null) {
        setIsredux(true);
      } else {
        setIsredux(false);
      }
      setExperience($('[name="work_day_activities"]').val())
          localStorage.setItem("job_role", $('[name="work_role"]').val())
          const filValue = (expe) => {
              if (message !== undefined && message !== null) {
                  if (AIexp.exp !== null) {
                      $('[name="work_day_activities"]').val(expe);
                  } else {
                      $('[name="work_day_activities"]').val(work[incr_defaultEdu]?.Day_to_day_work);
                  }
              } else {
                  if (AIexp.exp !== null) {
                      $('[name="work_day_activities"]').val(expe);
                  } else {
                      $('[name="work_day_activities"]').val();
                  }
              }
          }
            
            if (expe !== null) {
              filValue(expe);
            }
  
  
  }, [expe]);
  
  
  /* useEffect(() => {
    if (exp.activities !== null) {
      setChips(exp.activities);
      setwork(exp.activities);
    }
  }, []) */
  
  
    const handleSaveAndContinue = () => {
      if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
        // do sth here
        if ($('[name="work_place"]').val() !== "" || $('[name="work_day_activities"]').val() !== "") {
          handleAdd();
        } else {
          dispatch(updateExperience(newwork));
          dispatch(dispatchActivites(newwork));
          navigate(`/user/profile/:${userInfo.user.profile_id}`);
        }
      } else if (window.location.pathname === `/form/${cv.id}/update`) {
        if ($('[name="work_place"]').val() !== "") {
          handleAdd();
        }
        let generated_value = generated.message;
        generated_value.Experience = work;
        setObj(generated_value);
        dispatch(dispatchActivites(work));
        navigate("/allCv");
      } else {
        if (work.length === 0) {
          setTimeout(() => {
            toast.error("Add at least one experience", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }, 50);
        } else if ($('[name="work_place"]').val() !== "" || $('[name="work_day_activities"]').val() !== "") {
          setTimeout(() => {
            toast.error("Add the experience you just filled.", {
                position: toast.POSITION.TOP_RIGHT,
            });
          }, 50);
        } else {
          dispatch(dispatchActivites(work));
          if (stat === "false" || stat === false) {
            dispatch(saveExperience(work, secret.secret));
          }
          props.handleStepChange();
        }
      }
    }
  
    let year = [];
    for (let i = 1990; i <= 2023; i++) {
      year.push(`${i}`);
    }
  
  
    const handleDelete = (chipToDelete) => {
      if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
        const newWork = work.filter(element => {
          if (element._id !== chipToDelete._id)
              return element;
        })
        console.log("new work", newWork);
        newWork.forEach((element) => {
            element.key = newWork.indexOf(element);
        })
        /* 
        setwork((chips) => work.filter((chip) => chip.key !== chipToDelete.key )); */
        setwork(newWork);
        setChips(newWork);
        dispatch(dispatchActivites(newWork));
        dispatch(updateExperience(newWork))
      }
      // no need to setup a condition to test '/form/${cv.id}/update'
      const newWork = work.filter(element => {
        if (element.key !== chipToDelete.key)
            return element;
      })
      console.log("new work", newWork);
      newWork.forEach((element) => {
          element.key = newWork.indexOf(element);
      })/* 
      setwork((chips) => work.filter((chip) => chip.key !== chipToDelete.key )); */
      setChips(newWork);
      setwork(newWork)
      dispatch(dispatchActivites(newWork));
      console.log("chips", chips);
      console.log("delete work", work);
    }
  
    let month = [];
    for (let i = 0; i <= Months.length - 1; i++) {
      month.push(`${Months[i].value}`);
    }
  
    let mth = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"]
    const handleClickOperation = (desiredKey) => {
      if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
  
        let click_work = work;
        let desiredObject = click_work.find((item) => {
          console.log("item.key", item.key)
          if (item.key === undefined) {
            return item._id === desiredKey._id
          } else {
            return item.key === desiredKey.key;
          }
        });
        let w = click_work.filter(chip => {
          if (chip.key !== undefined) {
            return chip.key !== desiredObject.key;
          } else {
            return chip._id !== desiredObject._id
          }
        });
  
        $('[name="work_place"]').val(desiredObject.Where_i_worked);
        // $('[name="work_place"]').val(desiredObject.Where_i_worked_location);
         
         $('[name="work_role"]').val(desiredObject.My_job_title);
         localStorage.setItem("job_role", desiredObject.My_job_title);
          
          // if (AIexp.exp !== null) {
          //   $('[name="work_day_activities"]').val(AIexp.exp);
          // } else {
            $('[name="work_day_activities"]').val(desiredObject.Day_to_day_work);
            setColor(true);
            setExperience(desiredObject.Day_to_day_work);
          // }

          let startMonth, startYear;
          if (desiredObject.Work_start_date !== null && desiredObject.Work_start_date !== undefined) {
            startMonth = desiredObject.Work_start_date.split(" ")[0];
            startYear = desiredObject.Work_start_date.split(" ")[1];
            const firstMonth = new Date(startYear, mth.indexOf(startMonth));
            const firstYear = new Date(startYear);
            let i = firstMonth.getTime();
            let y = firstYear.getTime();
            console.log("Milli", i);
            console.log("Mil year", y);
            setExpStart(i);
            setExpEnd(y);
            
          }

          let endMonth, endYear;
          if (desiredObject.Work_end_date !== null && desiredObject.Work_end_date !== undefined) {
            if (desiredObject.Work_end_date === "Present") {
              $('#present').prop("checked", true);
              setE_Present(true);
            } else {
              $('#present').prop("checked", false);
              setE_Present(false);
              const secondMonth = new Date(endYear, mth.indexOf(endMonth));
              const secondYear = new Date(endYear);
              let sm = secondMonth.getTime();
              let sy = secondYear.getTime();
              console.log("sm", sm);
              console.log("sy", sy);
              setExpStart1(sm);
              setExpEnd1(sy);
            }
          }
  
          if(isRedux === true){
            $('[name="work_start_date"]').val(desiredObject.Work_start_date);
            $('[name="work_end_date"]').val(desiredObject.Work_end_date);
          }
        
        console.log("desired object", desiredObject);
        w.forEach((element) => {
            element.key = w.indexOf(element);
            console.log("work key", w.indexOf(element));
        });
        setwork(w);
          setChips(w);
          desiredObject = [];
    
          console.log("inner chips", chips);
          console.log("inner work", w);
      } else {
        let click_work = work;
      let desiredObject = click_work.find((item) => item.key === desiredKey.key);
      let w = click_work.filter(chip => chip.key !== desiredObject.key);
      
      $('[name="work_place"]').val(desiredObject.Where_i_worked);
      // $('[name="work_place"]').val(desiredObject.Where_i_worked_location);
       
       $('[name="work_role"]').val(desiredObject.My_job_title);
       localStorage.setItem("job_role", desiredObject.My_job_title);

       let startMonth, startYear;
       if (desiredObject.Work_start_date !== null && desiredObject.Work_start_date !== undefined) {
         startMonth = desiredObject.Work_start_date.split(" ")[0];
         startYear = desiredObject.Work_start_date.split(" ")[1];

         const firstMonth = new Date(startYear, mth.indexOf(startMonth));
         const firstYear = new Date(startYear);
         let i = firstMonth.getTime();
         let y = firstYear.getTime();
         console.log("Milli", i);
         console.log("Mil year", y);
         setExpStart(i);
         setExpEnd(y);
       }

       let endMonth, endYear;
       if (desiredObject.Work_end_date !== null && desiredObject.Work_end_date !== undefined) {
         if (desiredObject.Work_end_date === "Present") {
           $('#present').prop("checked", true);
           setE_Present(true);
         } else {
           $('#present').prop("checked", false);
           setE_Present(false);
           const secondMonth = new Date(endYear, mth.indexOf(endMonth));
           const secondYear = new Date(endYear);
           let sm = secondMonth.getTime();
           let sy = secondYear.getTime();
           console.log("sm", sm);
           console.log("sy", sy);
           setExpStart1(sm);
           setExpEnd1(sy);
         }
       }
        // if (AIexp.exp !== null) {
        //   $('[name="work_day_activities"]').val(AIexp.exp);
        // } else {
          $('[name="work_day_activities"]').val(desiredObject.Day_to_day_work);
          setExperience(desiredObject.Day_to_day_work);
        // }
  
        if(isRedux === true){
          $('[name="work_start_date"]').val(desiredObject.Work_start_date);
          $('[name="work_end_date"]').val(desiredObject.Work_end_date);
        }
      
      console.log("desired object", desiredObject);
      w.forEach((element) => {
          element.key = w.indexOf(element);
          console.log("work key", w.indexOf(element));
      });
      setwork(w);
        setChips(w);
        desiredObject = [];
        console.log("inner chips", chips);
        console.log("inner work", w);
      }
    }
  
    // handleClick function
    const handleClick = (desiredKey) => {
      const Where_i_worked = $('[name="work_place"]').val();
      const day_day_work = $('[name="work_day_activities"]').val()
      if (Where_i_worked !== "" && day_day_work !== "") {
          handleAdd(); // add already mapped values back to the work array if the client/user forget to click add, this is so, so as to save users experience.
          handleClickOperation(desiredKey);
      } else {
        setColor(true)
          handleClickOperation(desiredKey);
      }
    }
  
    console.log("new!!", newwork)
  
    // handle add function
    const handleAdd = () => {
      if ($('[name="work_place"]').val() == "") {
        setTimeout(() => {
          toast.error("Please fill form field before you can add.", {
              position: toast.POSITION.TOP_RIGHT,
          });
      }, 50);
      } else {
        console.log("current work length", work.length);
      dispatch(ActivitiesDetails_loading(true));
  
      
      const date1 = new Date(expStart);
      const date2 = new Date(expEnd);
  
      const date3 = new Date(expStart1);
      const date4 = new Date(expEnd1);
  
      const month1 = date1.toLocaleDateString('en-US', { month: 'short' })
      const year1 = date2.getFullYear();
  
      const month2 = date3.toLocaleDateString('en-US', { month: 'short' })
      const year2 = date4.getFullYear();
  
  
  
      let newWork = work;
                  const Where_i_worked = $('[name="work_place"]').val();
                  var Work_start_date;
                  var Work_end_date;
  
                  if (isRedux === true) {
                    Work_start_date = $('[name="work_start_date"]').val();
                    Work_end_date = $('[name="work_end_date"]').val();
                  } else {
                      Work_start_date = month1 + ' '+ year1;
                      if (e_present == true) {
                        Work_end_date = "Present";
                      } else {
                        Work_end_date = month2 + ' '+ year2; 
                      }
                  }
  
                  const k = work.length + 1;
                  const data =  {
                      key : k,
                      Where_i_worked: $('[name="work_place"]').val(),
                      Where_i_worked_location: $('[name="work_place"]').val(),
                      My_job_title:  $('[name="work_role"]').val(),
                      Work_start_date : Work_start_date,
                      Work_end_date : Work_end_date,
                      Day_to_day_work: $('[name="work_day_activities"]').val(),
                      // Achievement_and_recognition: data.get('work_recognition'),
                  }
                  if(Where_i_worked == '') {
                      return;
                  }
                  console.log("Add func chips", chips);
                  newWork.push(data);
                  newWork.forEach(element => {
                      element.key = newWork.indexOf(element);
                  })
                  if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
                    setNewWork(newWork);
                    setActivities(newWork);
                    setChips(newWork);
                    dispatch(dispatchActivites(newWork));
                  } else {
                    setwork(newWork);
                    setChips(newWork);
                    setActivities(newWork);
                    dispatch(dispatchActivites(newWork));
                  }
                  
                  setExpStart("");
                  setExpEnd("");
                  setExpStart1("");
                  setExpEnd1("");
                  $('#present').prop('checked', false);
                  setE_Present(false);
                  $('[name="work_place"]').val('');
                  $('[name="work_role"]').val('');
                  $('[name="work_day_activities"]').val('');
                  if (isRedux == true) {
                    Work_start_date = $('[name="work_start_date"]').val("");
                    Work_end_date = $('[name="work_end_date"]').val("");
                  }
                  
                  // clear the job role stored in localStorage
                  localStorage.removeItem("job_role");
                  dispatch(cleanEX());
                  setExperience("");
      }
    }
  
    const generateExperience = () => {
  
      dispatch(cleanEX());
          if (localStorage.getItem("job_role") === null) {
              setTimeout(() => {
                  toast.error(language["toast_job"], {
                      position: toast.POSITION.TOP_RIGHT,
                  });
              }, 50);
              return false;
          } else if (localStorage.getItem("job_role") !== null) {
              
              /* console.log("increment", incr_defaultEdu)
              console.log("work", work[incr_defaultEdu]?.Day_to_day_work) */
              if (message !== undefined && message !== null) {
                  console.log("experience", experience);
                  if (work.length !== 0) {
                      
                  }
  
                  if (experience !== "" && localStorage.getItem("job_role") !== null ) {
                      setTruty(true);
                      const cred = {
                          Experience: experience,
                          CvType: localStorage.getItem("job_role"),
                      }
                      dispatch(generate_experience(cred));
                  } else {
                      let text
                      if (localStorage.getItem("job_role") === null) {
                          text = language["toast_job"];
                      }
                      if ( experience === "" ) {
                          text = language["toast_des"]
                      }
                      setTimeout(() => {
                          toast.error(text, {
                              position: toast.POSITION.TOP_RIGHT,
                          });
                      }, 50);
                      return false;
                  }
  
  
              } else {
                  console.log("experience", experience);
                  if (experience !== "" && localStorage.getItem("job_role") !== null ) {
                      setTruty(true);
                      const cred = {
                          Experience: experience,
                          CvType: localStorage.getItem("job_role")
                      }
                      dispatch(generate_experience(cred));
                  } else {
                      let text
                      if (localStorage.getItem("job_role") === null) {
                          text = language["toast_job"];
                      }
                      if ( experience === "" ) {
                          text = language["toast_des"]
                      }
                      setTimeout(() => {
                          toast.error(text, {
                              position: toast.POSITION.TOP_RIGHT,
                          });
                      }, 50);
                      return false;
                  }
              }
            }
      
      return;
    }

    const handleBack = () => {
      if ($('[name="work_place"]').val() !== "" || $('[name="work_day_activities"]').val() !== "") {
        setTimeout(() => {
          toast.error("Add the experience you just filled.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      } else {
        props.handleStepChangeBack();
      }
    }
  
    let text
    if (AIexp.errMess === null) {
      text = `${language["modal_ai"]}`;
    } else {
      text = `${language["error"]}`;
    }
    

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      <div className="px-3 lg:pl-6 my-8 w-full">
        <div className="w-full max-w-[793px] h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
          <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
            {language["resume_caph1"]}
          </p>
        </div>
        <p className="w-full max-w-[741px] mt-2">
          <span className="text-black text-opacity-50 text-[14px] md:text-base font-normal px-3 lg:pl-6">
            {language["Hey_there"]}
          </span>
        </p>
        <div className="max-w-[800px] w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
          <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
            <Tab num="1" current={false} completed={true} />
            <Tab num="3" current={false} completed={true} />
            <Tab
              // label="Work Experience"
              label={`${language["work_experience"]}`}
              current={true}
              completed={false}
            />
            <Tab num="4" current={false} completed={false} />
            <Tab num="5" current={false} completed={false} />
            <Tab num="6" current={false} completed={false} />
            <Tab num="7" current={false} completed={false} />
            <Tab num="8" current={false} completed={false} />
            <Tab num="9" current={false} completed={false} />
          </div>
          {message !== undefined && message !== null ? (
            <div className="sm:mt-2 mb-4 py-2 px-4 sm:mb-2 sm:py-0">
              <h6 className="top-2 text-[24px] text-pry-920 sm:text-sm">
                {language["text"]}
              </h6>
            </div>
          ) : null}
          <div className="flex-col justify-start items-start gap-12 flex w-full">
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="companyWorked"
                >
                  {language["where_work"]}
                </label>
              </div>
              <TextInput
                placeholder={`${language["workplace_place"]}`}
                id="companyWorked"
                name="work_place"
                onChange={(event) =>
                  localStorage.setItem("Where_i_worked", event.target.value)
                }
              />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="jobTitle"
                >
                  {language["what_job_title"]}
                </label>
              </div>
              <TextInput
                placeholder={`${language["title_place"]}`}
                id="jobTitle"
                name="work_role"
                onChange={(event) =>
                  localStorage.setItem("job_role", event.target.value)
                }
              />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="durationOfStudy"
                >
                  {language["when_start_end"]}
                </label>
              </div>
              {isRedux == true ? null : 
                <p className="text-zinc-400 text-base font-medium">
                {language["select_start_end"]}</p>
              }
              <div className="w-full flex-col flex gap-3">
                {isRedux == true ? 
                  <div className="flex-col justify-start items-start gap-2 flex w-full">
                    <div className="flex gap-3 items-center"></div>
                    <TextInput
                      placeholder={`${language["month_year"]}`}
                      id="jobTitle"
                      name="work_start_date"
                    />
                  </div>
                  : 
                  <div className="w-full flex flex-col sm:flex-row gap-2">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker", "DatePicker", "DatePicker"]}
                      >
                        <DatePicker
                          label={`${language["month_place"]}`}
                          views={["month"]}
                          value={dayjs(expStart)}
                          onChange={(event) => setExpStart(event)}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker", "DatePicker", "DatePicker"]}
                      >
                        <DatePicker
                          label={`${language["year_place"]}`}
                          name="startYear"
                          views={["year"]}
                          value={dayjs(expEnd)}
                          onChange={(endValue) => setExpEnd(endValue)}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                }
                  {/* <div className="flex h-[54px] max-w-[500px] gap-3">
                )}
                {/* <div className="flex h-[54px] max-w-[500px] gap-3">
                  <BasicSelect
                    placeholder="Start Month"
                    labelId="startMonth"
                    selectMenu="work_start_month"
                    id="startMonth"
                    menuItems={[ ...month ]}
                  />
                  <BasicSelect
                    placeholder="Start Year"
                    labelId="startYear"
                    selectMenu="work_start_year"
                    id="startYear"
                    menuItems={[ ...year ]}
                  />
                </div> */}
                {isRedux === true ? (
                  <div className="flex-col justify-start items-start gap-2 flex w-full">
                    <div className="flex gap-3 items-center"></div>
                    <TextInput
                      placeholder={language["month_year"]}
                      id="jobTitle"
                      name="work_end_date"
                    />
                  </div>
                ) : (
                  <div className="w-full flex flex-col sm:flex-row gap-2">
                    {e_present === true ? null : 
                    <>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker", "DatePicker", "DatePicker"]}
                      >
                        <DatePicker
                          label={`${language["month_place"]}`}
                          views={["month"]}
                          value={dayjs(expStart1)}
                          onChange={(event) => setExpStart1(event)}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker", "DatePicker", "DatePicker"]}
                      >
                        <DatePicker
                          label={`${language["year_place"]}`}
                          name="startYear"
                          views={["year"]}
                          value={dayjs(expEnd1)}
                          onChange={(endValue) => setExpEnd1(endValue)}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    </>}
                    <div className="mt-3">
                        <Radio name="present" label="Present" id="present" />
                      </div>
                    </div>
                )}
                </div>
                {/* <div className="flex h-[54px] max-w-[500px] gap-3">
                      <BasicSelect
                        placeholder="End month"
                        labelId="code"
                        selectMenu="work_end_month"
                        id="endYear"
                        menuItems={[ ...month ]}
                      />
                      <BasicSelect
                        placeholder="End year"
                        labelId="code"
                        selectMenu="work_end_year"
                        id="endYear"
                        menuItems={[ ...year ]}
                      />
                    </div> */}
            </div>
            <div className="w-full">
              <div className="flex flex-col gap-3">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="firstName"
                  >
                    {language["in_own_words"]}
                  </label>
                </div>
                <div className="">
                  <TextArea
                    placeholder="0/300"
                    name="work_day_activities"
                    onChange={(event) => setExperience(event.target.value)}
                  />
                </div>
                <button
                  className={`max-w-max px-5 py-3 ${color === true ? `bg-orange-500` : `bg-pry-100`} rounded-3xl border justify-start items-start gap-2.5 inline-flex`}
                  onClick={() => {
                    experience !== "" ? generateExperience() : null;
                  }}
                >
                  <span className="text-center text-white text-base font-medium">
                    {language["generate_experience"]}
                  </span>
                </button>
                <span className="text-orange-500 text-base font-medium">Add, delete or edit the text generated by our AI too or regenerate</span>
              </div>
            </div>
            <div className="flex-col justify-start items-start gap-3 flex w-full">
              <AddMore text="experience" onClick={handleAdd} />
              <p className="text-black text-base font-medium">
                {language["have_added"]}
              </p>
              <div className="flex flex-wrap gap-3">
                {chips?.map((exp, key) => (
                  <AddedItem
                    item={exp.Where_i_worked}
                    key={key}
                    onClick={() => handleClick(exp)}
                    delete={() => handleDelete(exp)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
            {
              visibility == true ? null :
              <button
              className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
              onClick={handleBack}
            >
              <span className="text-center text-orange-500 text-base font-semibold">
                {language["previous_btn"]}
              </span>
            </button>
            }
            <button
              className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
              onClick={handleSaveAndContinue}
            >
              <span className="text-center text-white text-base font-semibold whitespace-nowrap">
                {language["save_n_continue"]}
              </span>
            </button>
          </div>
        </div>
      </div>
      {truty === true ? (
        AIexp.exp !== null ? (
          setTruty(false)
        ) : AIexp.errMess === null ? (
          <div>
            <LoaderModal text={text} />
          </div>
        ) : null
      ) : null}
      <ToastContainer />
    </div>
  );
}